Buyapowa.Controllers.MobileSharing = class MobileSharing {
  constructor(el) {
    this.el = el;
    this.view = new Buyapowa.Views.MobileSharing(this.el, this);
  }
};
